var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.80341C0 4.75262 0.738281 5.49091 1.6875 5.49091H2.25V7.74091H4.5V5.49091H7.875V7.74091H10.125V5.49091H13.5V7.74091H15.75V5.49091H16.3125C17.2266 5.49091 18 4.75262 18 3.80341V1.48309C18 1.20184 17.7891 0.990906 17.5078 0.990906C17.4375 0.990906 17.4023 1.02606 17.332 1.02606L15.6094 1.72919C14.9414 2.01044 14.2383 2.11591 13.5352 2.11591H4.42969C3.72656 2.11591 3.02344 2.01044 2.35547 1.72919L0.632812 1.02606C0.5625 1.02606 0.527344 0.990906 0.457031 0.990906C0.210938 0.990906 0 1.20184 0 1.48309V3.80341ZM2.25 11.1159V17.8659C2.25 18.4987 2.74219 18.9909 3.375 18.9909C3.97266 18.9909 4.5 18.4987 4.5 17.8659V11.1159H13.5V17.8659C13.5 18.4987 13.9922 18.9909 14.625 18.9909C15.2227 18.9909 15.75 18.4987 15.75 17.8659V11.1159H16.875C17.4727 11.1159 18 10.6237 18 9.99091C18 9.39325 17.4727 8.86591 16.875 8.86591H1.125C0.492188 8.86591 0 9.39325 0 9.99091C0 10.6237 0.492188 11.1159 1.125 11.1159H2.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default ForwardRef;